// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3vl_E","text":"SelectPayment_text__2qKOo","title":"SelectPayment_title__3uaVb","btn":"SelectPayment_btn__1j1bq"};